export const GREEN = '#b4de85';
export const RED = '#ff252f';
export const ORANGE = '#ffc86e';

export const ALERT = RED;
export const WARNING = ORANGE;
export const SUCCESS = GREEN;
